var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pending_svg__a)",
  filter: "url(#pending_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 49,
  r: 35,
  fill: "#F8B24F"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 49,
  r: 26,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8B24F",
  fillRule: "evenodd",
  d: "M45.115 32a3.115 3.115 0 0 1 3.116 3.115V52.77h9.346a3.115 3.115 0 1 1 0 6.231H45.115A3.115 3.115 0 0 1 42 55.885v-20.77A3.115 3.115 0 0 1 45.115 32Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pending_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h100v100H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "pending_svg__b",
  width: 108,
  height: 108,
  x: -5,
  y: -1,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 3,
  result: "effect1_dropShadow_1799_1270"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1799_1270"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1799_1270",
  result: "shape"
})))));
export default SvgPending;